module.exports = __webpack_public_path__ + "static/media/QBO-auto-import-invoices.c99db995.png";